export default {
    methods: {
        capitalise_string(s) {
            if(typeof s !== 'string') return ''
            return s.charAt(0).toUpperCase() + s.slice(1)
        },
        convert_date(ISO_date) {
            // Converts the ISO data format '2020-09-30T09:18:29.044Z' into something more useful
            if(ISO_date == '0000-00-00 00:00:00' ) {
                return '-';
            } else {
                var date = new Date(ISO_date);
                var year = date.getFullYear();
                var month = date.getMonth()+1;
                var day =  date.getDate();
                // Make a 'presentable' date
                if (day < 10) {
                    day = '0' + day;
                }
                // The first value in the array is blank as a month is never 0, and the index of the first item is 0
                const month_names = [
                    '', 
                    'January', 
                    'February', 
                    'March', 
                    'April', 
                    'May', 
                    'June', 
                    'July', 
                    'August', 
                    'September', 
                    'October', 
                    'November', 
                    'December'
                ];
                // Now compile the final date
                return day + ' ' + month_names[month] + ' ' + year;
            }
        },
        compare_objects(o1, o2) {
            var k = '';
            for(k in o1) if(o1[k] != o2[k]) return false;
            for(k in o2) if(o1[k] != o2[k]) return false;
            return true;
        },
        item_exists(haystack, needle) {
            for(var i=0; i<haystack.length; i++) if(this.compare_objects(haystack[i], needle)) return true;
            return false;
        },
        stringify_array(array) {
            return array.join(',');
        },
        trim_string(s) {
            var l=0, r=s.length -1;
            while(l < s.length && s[l] == ' ') l++;
            while(r > l && s[r] == ' ') r-=1;
            return s.substring(l, r+1);
        }
    }
}